/* eslint-disable @typescript-eslint/naming-convention */
export interface AbsorbDateUpdateDto {
  ProspectId: string | null;
  HRRef: number | null;
  AbsorbDateUpdated: Date | null;
}
